import { INBOX_TYPES, SMS_CHANNELS_GROUP } from 'dashboard/helper/inbox';

export const DEFAULT_MESSAGE_CREATED_CONDITION = [
  {
    attribute_key: 'message_type',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_CONVERSATION_OPENED_CONDITION = [
  {
    attribute_key: 'browser_language',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

// Most rules of a finished call are for missed calls
export const DEFAULT_PHONE_CALL_FINISHED_CONDITION = [
  {
    attribute_key: 'missed_call',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_OTHER_CONDITION = [
  {
    attribute_key: 'status',
    filter_operator: 'equal_to',
    values: '',
    query_operator: 'and',
    custom_attribute_type: '',
  },
];

export const DEFAULT_ACTIONS = [
  {
    action_name: 'assign_agent',
    action_params: [],
  },
];

export const MESSAGE_CONDITION_VALUES = [
  {
    id: 'incoming',
    name: 'Incoming Message',
  },
  {
    id: 'outgoing',
    name: 'Outgoing Message',
  },
  {
    id: 'private',
    name: 'Private Note',
  },
  {
    id: 'ai_summary',
    name: 'AI Summary',
  },
];

// `name` is the English fallback; the UI shows the translated
// CONVERSATION.PRIORITY.OPTIONS.<i18nKey> label.
export const PRIORITY_CONDITION_VALUES = [
  { id: 'nil', name: 'None', i18nKey: 'NONE' },
  { id: 'low', name: 'Low', i18nKey: 'LOW' },
  { id: 'medium', name: 'Medium', i18nKey: 'MEDIUM' },
  { id: 'high', name: 'High', i18nKey: 'HIGH' },
  { id: 'urgent', name: 'Urgent', i18nKey: 'URGENT' },
];

// For the lists below `name` is the English fallback; the UI shows the
// translated `i18nKey` label (see useAutomationValues). Brand names have no
// i18nKey and are shown as they are.
export const CALL_DIRECTION_VALUES = [
  {
    id: 'inbound',
    name: 'Inbound',
    i18nKey: 'FILTER.PHONE_CALL_TYPES.INBOUND',
  },
  {
    id: 'outbound',
    name: 'Outbound',
    i18nKey: 'FILTER.PHONE_CALL_TYPES.OUTBOUND',
  },
];

export const MISSED_CALL_VALUES = [
  { id: true, name: 'Yes', i18nKey: 'AUTOMATION.YES_NO_VALUES.YES' },
  { id: false, name: 'No', i18nKey: 'AUTOMATION.YES_NO_VALUES.NO' },
];

export const EMAIL_AUTO_REPLY_VALUES = MISSED_CALL_VALUES;

// working_hours and agent_replied
export const YES_NO_VALUES = MISSED_CALL_VALUES;

export const MESSAGE_SOURCE_TYPE_VALUES = [
  {
    id: 'facebook_messenger',
    name: 'Facebook Messenger',
    i18nKey: 'AUTOMATION.MESSAGE_SOURCE_TYPE_VALUES.FACEBOOK_MESSENGER',
  },
  {
    id: 'instagram_direct_message',
    name: 'Instagram DM',
    i18nKey: 'AUTOMATION.MESSAGE_SOURCE_TYPE_VALUES.INSTAGRAM_DM',
  },
  {
    id: 'facebook_comment',
    name: 'Facebook Comment',
    i18nKey: 'AUTOMATION.MESSAGE_SOURCE_TYPE_VALUES.FACEBOOK_COMMENT',
  },
];

// Channel types of an inbox, used by the automation "Channel Type" condition.
// Ids are the `Channel::*` class strings stored in inboxes.channel_type, sourced
// from INBOX_TYPES so they never drift from the canonical list. An option id may
// also be a group token (e.g. SMS_CHANNELS_GROUP) expanded by the backend.
export const CHANNEL_TYPE_VALUES = [
  {
    id: INBOX_TYPES.WEB,
    name: 'Website',
    i18nKey: 'INBOX_MGMT.CHANNELS.WEB_WIDGET',
  },
  { id: INBOX_TYPES.FB, name: 'Facebook' },
  { id: INBOX_TYPES.TWITTER, name: 'Twitter (X)' },
  { id: INBOX_TYPES.WHATSAPP, name: 'WhatsApp' },
  {
    id: INBOX_TYPES.EMAIL,
    name: 'Email',
    i18nKey: 'INBOX_MGMT.CHANNELS.EMAIL',
  },
  { id: INBOX_TYPES.API, name: 'API' },
  { id: SMS_CHANNELS_GROUP, name: 'SMS', i18nKey: 'INBOX_MGMT.CHANNELS.SMS' },
  { id: INBOX_TYPES.TELEGRAM, name: 'Telegram' },
  { id: INBOX_TYPES.INSTAGRAM, name: 'Instagram' },
  {
    id: INBOX_TYPES.PHONE,
    name: 'SIP Phone',
    i18nKey: 'INBOX_MGMT.CHANNELS.PHONE',
  },
  { id: INBOX_TYPES.SALESFORCE, name: 'Salesforce' },
  { id: INBOX_TYPES.ALLEGRO, name: 'Allegro' },
  { id: INBOX_TYPES.KAUFLAND, name: 'Kaufland' },
];
